const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getTimelineItemsDataSetQueryOptions } from '@/lib/queries/loop-planner/useGetTimelineItemsDataSet';
import { isHttpError } from '@/lib/utils/common/isHttpError';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/')({
  loader: async ({
    params: {
      loopId,
      org,
      scenarioId
    },
    context: {
      queryClient
    }
  }) => {
    try {
      await queryClient.ensureQueryData(getTimelineItemsDataSetQueryOptions({
        loopId: Number(loopId),
        scenarioId
      }));
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      if (isHttpError(error, 404)) {
        throw redirect({
          to: '/org/$org/loop/$loopId/planner/live/table',
          params: {
            org,
            loopId
          }
        });
      }
      throw error;
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner
});